import * as types from "./modal.actionTypes";
import { action } from "typesafe-actions";

export const showModal = (title: string, description: string) =>
  action(types.SHOW_MODAL, { title, description });

export const dismissModal = () =>
  action(types.DISMISS_MODAL, { });